define('lq/events/actions/serverCommand',[
    'lq/events/actions/eventAction',
    'jquery',
    'underscore'
], function (EventAction, $, _) {
    'use strict';

    function ServerCommand(eventData, eventArg) {
    	EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ServerCommand, EventAction);

    ServerCommand.typeName = 'ServerCommand';

    ServerCommand.prototype.getBatchType = function () {
    	return EventAction.COMMAND_BATCH;
    };

    ServerCommand.prototype.createEventActionRequest = function () {
    	var commandViewModelKeysValues = {};

    	var self = this;
        _.each(this.piping.dropFactory.getAllDrops(), function(drop) {
	        if (drop.getValue) {
                var value = drop.getValue();
                commandViewModelKeysValues[drop.data.viewModelKey] = value;
            }
	    });

    	return {
    		eventActionType: "ServerCommand",
    		command: self.eventData.command,
    		commandViewModelKeys: commandViewModelKeysValues
    	};
    };

    return ServerCommand;
});
